<template>
    <el-dialog
class="Dellog"
      :visible.sync="visibleInternal"
width="416px"
:show-close="false"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <!-- 默认插槽用于主要内容 -->
       <div class="Dialog-Content">
        <div class="Dialog-Content-h">
            <img src="../assets1//后台//音频备份 3.png" class="Wanring" alt="" v-if="type!==3">
            <div class="Header-text" :class="type===3?'Reject':''" style="font-size: 24px;">{{ title }}</div>
        </div>
        <div :class="['Dialog-Content-c',type===3?'mb':'',type===3?'Dialog-Content-c-text':'']" >
          {{content}}
        </div>
        <div class="Dialog-Content-c" :class="type===3?'Dialog-Content-c-text':''">
          <div class="Dialog-Content-input">
            <el-input type="textarea"  resize="none" v-model="input" placeholder="请输入驳回原因" />
          </div>
        </div>
       </div>
      
      <!-- 具名插槽用于底部按钮 -->
      <template #footer>
        <slot name="footer" v-if="type===2">
          <el-button class='DialogBtn' @click="handleClose" >取消</el-button>
          <el-button class='DialogBtn OKDel'  @click="handleConfirm">删除需求</el-button>
        </slot>
        <slot name="footer" v-else-if="type===1">
          <el-button class='DialogBtn' @click="handleClose" >取消</el-button>
          <el-button class='DialogBtn OKDel'  @click="handleConfirm">发布需求</el-button>
        </slot>
        <slot name="footer" v-if="type===3">
          <el-button class='DialogBtn' @click="handleClose" >取消</el-button>
          <el-button class='DialogBtn OKDel'  @click="RejectOk">驳回需求</el-button>
        </slot>
      </template>
    </el-dialog>
  </template>
  
  <script>
  export default {
    name: 'BaseDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
      
      },
      width: {
        type: String,
        default: '50%'
      },
      content:{
        type:String
      },
      type:{
        type:Number
      },
     
    },
    data() {
      return {
        visibleInternal: this.visible,
        input:''
      }
    },
    watch: {
      visible(newVal) {
        this.visibleInternal = newVal
      }
    },
    methods: {
      RejectOk(){
        this.$emit('confirm',this.input)
      },
      handleClose() {
        this.visibleInternal = false
        this.$emit('update:visible', false)
        this.$emit('close')
      },
      handleConfirm() {
        this.$emit('confirm')
        this.$emit('Del')
      }
    }
  }
 
  </script>
  <style scoped>
  .mb{
    margin-bottom: 5px !important;
  }
  .Reject{
    margin-left: 0px !important;
  }
  ::v-deep .el-textarea__inner:placeholder{
    font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #C1C1C1;
line-height: 20px;
  }
  ::v-deep .el-textarea__inner{
    height: 100px;
    font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #C1C1C1;
line-height: 20px;
  }
  .Dialog-Content-c-text{
    margin-left: 0px !important;
  }
 
   .DialogBtn:hover{
    background-color: #fff !important;
    color: #999999;
    border-color: #D9D9D9;
   }
   .OKDel:hover{
    background-color: #0D53FF !important;
    color: #fff !important;
    border-color: transparent;
   }
  .OKDel{
    background-color: #0D53FF;
    color: #fff !important;
  }
  .DialogBtn{
   padding:7px 16px;
    border-radius: 4px;
    color: #999999;
  }
  .Dialog-Content-c{
    margin-left: 42px;
    font-family: Regular;
    font-size: 18px;
    color: #666;
  }
  .Dialog-Content-h{
    display: flex;
    margin-bottom: 20px;
  }
  .Dellog .Header-text{
    margin-left: 14px;
    font-size: 24x;
    font-family: Medium;
    color: #222;
    line-height: 28px;
  }
.Wanring{
    width: 28px;
    height: 28px;
}
</style>
  <style>
  .Dellog .el-dialog{
    border-radius: 12px;
  }
  .Dellog .el-dialog .el-dialog__body{
 padding: 0 40px 27px 40px;
  }
</style>